export default __webpack_public_path__ + "static/media/prev-MDS-3.ef5d2b39.png";